import React, { lazy, useEffect } from "react";
import { useRoutes, useNavigate } from "react-router";
import styled from "styled-components";
import DashHeader from "../Dashboard/DashHeader";
import DashAppointment from "../Dashboard/DashAppoint";
import DashFund from "../Dashboard/DashFund2";
import DashFundWallet from "../Dashboard/DashFundWallet";
import DashHMO from "../Dashboard/Dashhmo";
import DashSettings from "../Dashboard/DashSettings";
import DashTransPage from "../Dashboard/DashTransPage";
import DashSiderBar from "../Dashboard/DashSiderBar";
import { useAppSelector } from "../Global/Store";
import DashHistoryDetail from "../Dashboard/DashHistoryDetail";
import TransPop1 from "../Dashboard/DashTransPops/TransPop1";
// import DashHomeComp from "../Dashboard/DashHome/DashHomeComp";

const DashHomeComp = lazy(() => import("../Dashboard/DashHome/DashHomeComp"));

const DashBoardRoute = () => {
  const getUser = useAppSelector((state) => state?.currentUser);
  const navigate = useNavigate();
  useEffect(() => {
    if (!getUser?.next_of_kin) {
      navigate("/signin", { replace: true });
    }
  }, []);
  const element = useRoutes([
    {
      path: "/dashboardhome",
      element: <DashHomeComp />,
    },
    {
      path: "/transactions",
      element: <DashTransPage />,
    },
    {
      path: "/makeappointment",
      element: <DashAppointment />,
    },
    {
      path: "/fundwallet",
      element: <DashFundWallet />,
    },
    {
      path: "/settings",
      element: <DashSettings />,
    },
    {
      path: "/hmo",
      element: <DashHMO />,
    },
    {
      path: "/fund",
      element: <DashFund />,
    },
    {
      path: "/historyDetail",
      element: <DashHistoryDetail />,
    },
    {
      path: "/transpop1",
      element: <TransPop1 />,
    },
  ]);

  return (
    <>
      <Body>
        <Head>
          <DashHeader />
        </Head>

        <Bottom>
          <Side>
            <DashSiderBar />
          </Side>

          <DashRoute>{element}</DashRoute>
        </Bottom>
      </Body>
    </>
  );
};

export default DashBoardRoute;

// const DashHead = styled.div``;

const DashRoute = styled.div`
  width: calc(100% - 275px);
  height: 100%;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

const Side = styled.div`
  width: 250px;
  height: 100vh;
  /* position: fixed; */

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const Bottom = styled.div`
  width: 100%;
  display: flex;
`;

const Head = styled.div`
  width: 100%;
  height: 65px;
`;

const Body = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #eaeaea;
`;

// cool
